import { makeAutoObservable, reaction } from "mobx";
import { prefApi } from "./api";
import axios from "axios";
class Events {
  curent_page = 1;
  curent_item = 0;
  max_pages = 5;
  page_limit = 5;
  total = 1;
  pages = [];
  loading = false;
  currentpage = undefined;
  constructor() {
    makeAutoObservable(this);
    this.fetchEvents();
  }

  goNextPage() {
    const targetPage = this.curent_page + 1;
    if (this.max_pages >= targetPage) this.curent_page = targetPage;
  }
  goPrewPage() {
    const targetPage = this.curent_page - 1;
    if (targetPage > 0) this.curent_page = targetPage;
  }
  goNextItem() {
    const targetItem = this.curent_item + 1;

    if (
      this.total > targetItem &&
      typeof this.pages[targetItem] !== "undefined"
    )
      this.curent_item = targetItem;
    const targetPage = Math.ceil(this.curent_item / this.page_limit) + 1;
    if (this.curent_page < targetPage) this.curent_page = targetPage;
  }
  goPrewItem() {
    const targetItem = this.curent_item - 1;
    if (targetItem >= 0) this.curent_item = targetItem;
  }



  get page() {
    console.warn("PAGE");
    console.log("currentItemId::" + this.curent_item);
    console.log("currentPageId::" + this.curent_page);
    console.log("total::" + this.total);
    console.log(this.pages);
    console.log(this.pages[this.currentItemId]);
    return this.pages[this.currentItemId];
  }
  get currentPageId() {
    return this.curent_page;
  }
  get currentItemId() {
    return this.curent_item;
  }
  get getLoading() {
    return this.loading;
  }
  addPage(page) {
    let index = -1;
    console.error("PAGE #" + page.id);
    console.error(page);
    for (let i = 0; i < this.pages.length; i++) {
      if (this.pages[i].id === page.id) {
        console.log("REPLACE PAGE" + this.pages[i].id + " === " + page.id);
        index = i;
      }
    }

    if (index > -1) {
      this.pages[index] = page;
    } else {
      console.log("ADD NEW PAGE");
      this.pages.push(page);
    }
  }
  addPages(newPages) {
    for (let i = 0; i < newPages.length; i++) {
      this.addPage(newPages[i]);
    }
    // this.pages = [...this.pages];
    console.log(this.currentPageId);
  }
  fetchEvents() {
    console.log("UPLOAD PAGE:" + this.curent_page);
    this.loading = true;
    /* fetch('/api/events/get', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ limit: this.page_limit, page: this.curent_page })
        })
            .then(resp => resp.json())
            .then(json => { }) */
    axios
      .post(prefApi + "/events/get", {
        limit: this.page_limit,
        page: this.curent_page,
      })
      .then((response) => {
        console.log(response);
        this.loading = false;
        if (response.data.errorCode === 0) {
          console.log("Data ok!");
          this.addPages(response.data.data.data);

          this.total = response.data.data.total;
        }
        /*  this.categories = response.data; */
      })
      .catch((error) => console.error(error));
  }
}
const EventsObj = new Events();
reaction(
  () => EventsObj.currentPageId,
  (value, previousValue, reaction) => {
    if (value > previousValue) {
      console.log("GROWS UP! " + previousValue + "-->" + value);
      EventsObj.fetchEvents();
    } else {
      console.log("NOT GROWS UP! " + previousValue + "-->" + value);
    }
  }
);
export default EventsObj;
